module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select":"Selection:","all":"all","none":"none","invert":"invert"},"fr":{"select":"Sélection :","all":"tout","none":"aucun","invert":"inverse"}}')
  delete Component.options._Ctor
}
